import React, { Suspense } from 'react';
import { Container, ProgressBar, Row, Image } from 'react-bootstrap';
import { renderRoutes } from "react-router-config";
const Logout = (props) => {
  const { route } = props;

  return (
    <Container fluid>
      <Suspense fallback={<ProgressBar striped />}>
        {renderRoutes(route.routes)}
      </Suspense>
    </Container>
  );
}

export default Logout;

